import "@/App.css";
import { useEffect, useRef } from "react";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { BookingProvider } from "@/context/booking";
import { Nav, FloatingBook } from "@/components/site/Nav";
import { BookingDialog } from "@/components/site/Forms";
import Home from "@/pages/Home";

function App() {
  const lenisRef = useRef(null);
  useEffect(() => {
    const id = setInterval(() => {
      if (lenisRef.current?.lenis) { window.__lenis = lenisRef.current.lenis; clearInterval(id); }
    }, 200);
    return () => clearInterval(id);
  }, []);
  return (
    <ReactLenis ref={lenisRef} root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App grain">
        <BrowserRouter>
          <BookingProvider>
            <Nav />
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
            <FloatingBook />
            <BookingDialog />
            <Toaster position="top-center" richColors />
          </BookingProvider>
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
